import "../../../public/vendor/jquery/dist/jquery.js"
import "../../../public/vendor_modified/supersized/slideshow/js/supersized.3.2.7.js"
import "../../../public/vendor_modified/supersized/slideshow/theme/supersized.shutter.js"
var req = require.context('../../../public/javascripts/backbone/lib/concerns/', true, /\.js$/)
req.keys().forEach(req)
